import bxlutils from 'bxl-utils'

export const SHARE = {
    title: '',
    description: '',
    icon: ''
}
export const BYH5 =
    process.env.REACT_APP_BASE_ENV === 'dev'
        ? 'https://baleen-dev-cdn-g.bybieyang.com/static/html/byh5/index.html'
        : 'https://baleen-cdn-g.bybieyang.com/static/html/byh5/index.html'
export const BXL_USER_ID = 'BXL_USER_ID'
export const BXL_USER_KEY = 'BXL_USER_KEY'
export const BXL_GUEST_ID = 'BXL_GUEST_ID'

export const BASE_HOST = {
    grotto: {
        prod: 'https://santa-grotto.santasmartnetwork.com',
        dev: 'https://santa-grotto-dev.santasmartnetwork.com'
    },
    laas: {
        prod: 'https://santa-laas.santasmartnetwork.com',
        dev: 'https://santa-laas-dev.santasmartnetwork.com'
    },
    ewe: {
        prod: 'https://santa-ewe.santasmartnetwork.com',
        dev: 'https://santa-ewe-dev.santasmartnetwork.com'
    }
}
const channel = window.location.host.split('.')[0]
export const prodPath = () => {
    if (BASE_HOST[channel]) {
        return BASE_HOST[channel].prod
    }
    return 'https://5thave-prod.bieyangapp.com'
}
export const dogfoodPath = () => {
    if (BASE_HOST[channel]) {
        return BASE_HOST[channel].dev
    }
    return 'https://5thave-dev.bieyangapp.com'
}

//需要排除的商家

export const EXCLUDE_MERCHANT = [
    '6PM',
    'Brooks Brothers',
    "Church's",
    'Dim Mak',
    "Hudson's Bay",
    'Kate Spade',
    "Santa's grotto",
    'Smashbox Cosmetics',
    'Walgreens',
    "Sam's Club",
    'Urban Outfitters',
    'Space NK',
    'Juice Beauty',
    'Foot Locker',
    'Foot Locker UK',
    'Foreo',
    '别样头等仓',
    '品牌清仓区',
    '折扣挖宝区',
    'TwentyFourSEVRES',
    'Coggles',
    'Forzieri',
    'Harrods',
    'Harvey Nichols',
    'MATCHESFASHION',
    'MyBag',
    'Perricone MD',
    'Asos',
    'Space NK',
    'Designer childrenswear',
    'The Hut',
    'MyTheresa',
    'Allsole',
    'LNCC',
    'LussoItaliano',
    'LAMPOO ITALY',
    'NetAPorter',
    "Church's"
]
